import { ResponseCode } from '@/common/request/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';
import { arenaService } from '@/services/arena';
import { onMounted } from 'vue';

export function useArenaCycleList() {
    const router = useAppRouter();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: arenaService.cycle.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            transformResponse: async (list: any[]) => {
                const arenaIds = new Set(list.map(cycle => cycle.arenaId));
                const arenaResponse = await arenaService.item.getList(Array.from(arenaIds).join(','));

                if (arenaResponse.code === ResponseCode.Ok) {
                    const arenaNameMap = new Map<number, any>(
                        arenaResponse.data.map((item: any) => [item.id, item.name])
                    );

                    return list.map(cycle => ({
                        ...cycle,
                        arenaName: arenaNameMap.get(cycle.arenaId) || ''
                    }));
                } else {
                    router.push({ name: ROUTE_NAME_ARENA.ITEM.INDEX });
                    return [];
                }
            }
        }
    });

    onMounted(async () => {
        await fetchList();
    });

    return { list, total, query, fetchList, ArenaCycleStatus };
}

export const ArenaCycleStatus = [
    { label: 'None', value: 1, background: 'secondary' },
    { label: 'Published', value: 2, background: 'success' },
    { label: 'Started', value: 3, background: 'info' },
    { label: 'Closed', value: 4, background: 'warning' },
    { label: 'Ended', value: 5, background: 'danger' },
    { label: 'Unpublished', value: 6, background: 'warning' },
    { label: 'Disabled', value: 7, background: 'secondary' },
    { label: 'Archived', value: 8, background: 'secondary' }
];
